module.exports = __webpack_public_path__ + "img/14_6.4087a3de.png";